/* Lazysizes */
import 'lazysizes';

/* Alpine bootup */

import Alpine from 'alpinejs';
import AutoAnimate from '@marcreichel/alpine-auto-animate';
import focus from '@alpinejs/focus';

// import intersect from '@alpinejs/intersect'
// import persist from '@alpinejs/persist'

 import collapse from '@alpinejs/collapse'

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {

    Alpine.data("resetter", () => ({
        init() {
            let form = this.$root.closest("form");
            if (form) {
                form.addEventListener("reset", () => {
                    let inputs = form.querySelectorAll("input:not([type=button], [type=submit], [type=reset], [type=hidden], [type=checkbox], [type=radio], [x-ref=picker]");
                    for (input of inputs) {
                        input.defaultValue = "";
                        input.value = null;
                    }

                    let evt = document.createEvent("HTMLEvents");
                    evt.initEvent("change", false, true);
                    let checkboxes = form.querySelectorAll("[type=checkbox]:checked, [type=radio]:checked");
                    for (cb of checkboxes) {
                        if (cb.checked) {
                            cb.removeAttribute("checked");
                            cb.checked = false;
                            cb.dispatchEvent(evt);
                        }
                    }

                    let flatpickrClears = form.querySelectorAll("[x-ref=clearFlatpickr]");
                    evt.initEvent("click", false, true);
                    for (clear of flatpickrClears) {
                        clear.dispatchEvent(evt);
                    }
                })
            }
        }
    }));

    Alpine.store('modal', '')
    Alpine.store('showLogin', false)

    Alpine.store('bodyLock', {
        on: false,
        toggle() {
            this.on = ! this.on
        }
    })

    Alpine.data('bookmarkToggler', (nodeId = 0) => ({
        nodeId: nodeId,
        loading: false,
        isLoggedIn: false,
        isBookmarked: false,
        getBookmarkStatus() {
            this.loading = true;
            fetch(`/bookmarks/get/${this.nodeId}`)
                .then(res => res.json())
                .then(data => {
                    this.loading = false;
                    this.isBookmarked = data.isBookmarked;
                    this.isLoggedIn = data.isLoggedIn;
                }).catch(err => {
                    this.loading = false;
                    console.log(err);
                });
        },
        toggle() {
            this.loading = true;
            fetch(`/bookmarks/toggle/${this.nodeId}`, { method: 'POST' })
                .then(res => res.json())
                .then(data => {
                    this.loading = false;
                    this.isBookmarked = data.isBookmarked;
                    this.isLoggedIn = data.isLoggedIn;
                }).catch(err => {
                    this.loading = false;
                    console.log(err);
                });
        },
        init() {
            this.getBookmarkStatus();
        }
    }))

    Alpine.data('fetchBasedSearch', (formSelector = "form", articlesSelector = "#articles", paginationSelector = ".pagination a") => ({
        loading: false,
        form: null,
        articles: null,
        init() {
            this.articles = this.$root.querySelector(articlesSelector);
            this.form = this.$root.querySelector(formSelector);
            this.form.addEventListener("submit", (e) => {
                e.preventDefault();
                var params = new URLSearchParams(new FormData(this.form))
                var newUrl = window.location.origin + window.location.pathname + "?" + params.toString();
                history.pushState({}, '', newUrl)

                fetch(newUrl)
                    .then(response => response.text())
                    .then(html => {
                        this.swapContent(html);
                        this.loading = false;
                    })
                    .catch(err => {
                        console.error(err);
                        this.loading = false;
                    })
            })
            this.handlePaginationLinks();
        },
        handlePaginationLinks() {
            const links = this.articles.querySelectorAll(paginationSelector);
            links.forEach((link) => {
                link.addEventListener("click", (e) => {
                    e.preventDefault();
                    history.pushState({}, '', link.href);

                    this.loading = true;
                    fetch(link.href)
                        .then(response => response.text())
                        .then(html => {
                            this.swapContent(html);
                            this.loading = false;
                        })
                        .catch(err => {
                            console.error(err);
                            this.loading = false;
                        })
                })
            })
        },
        swapContent(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            this.articles.innerHTML = doc.querySelector(articlesSelector).innerHTML;
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.articles.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            });
            this.handlePaginationLinks();
        }
    }))
})

Alpine.plugin(AutoAnimate);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.start();



// Alpine.plugin(intersect);
// Alpine.plugin(persist);

// Alpine.plugin(collapse);

/* aspnet-client-validation bootup */

// import { ValidationService } from 'aspnet-client-validation';

// let v = new ValidationService();
// v.bootstrap();